<template>
  <aside class="leave-modal">
    <div class="leave-modal__content uk-container">
      <h2 class="page-section__title">Chcesz nas opuścić?</h2>
      <div class="leave-modal__actions">
        <button class="button button--shadow" @click="closeModalHandler">opuszczam stronę</button>
        <button class="button button--shadow button--arrow" @click="$emit('close-leave')">
          kontynuuję wypełnianie ankiety
        </button>
      </div>
    </div>
  </aside>
</template>
<script>
export default {
  name: "LeaveModal",
  methods: {
    closeModalHandler() {
      window.location = "/";
    },
  },
};
</script>
<style scoped lang="scss">
.leave-modal {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: $white;
  z-index: 1000;
  display: flex;
  flex-direction: column;

  &__content {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__actions {
    @include media-min($md) {
      display: flex;
    }

    .button {
      width: 100%;

      @include media-min($md) {
        width: auto;
      }

      &:first-child {
        margin-bottom: rem(20px);

        @include media-min($md) {
          margin-bottom: unset;
          margin-right: rem(20px);
        }
      }
    }
  }
}
</style>
